<div class="custom-header" (dblclick)="toggleRollupGroup()">

  <span class="header-title" *ngIf="isRollupHeader===false">
    <span class="group-name" title="{{params.value}}">{{params.value}}</span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks>0"><a href="#" (click)="this.showNhtpDialog($event)">{{this.newHireTrainingWeeks}} {{"multi.mu.group.nhtp"|translate}}</a></span>
    <span class="nhtp-link" *ngIf="this.newHireTrainingWeeks==0"><a href="#" (click)="this.showNhtpDialog($event)">{{"multi.mu.group.nhtp.no.value"|translate}}</a></span>
  </span>
  <span class="ag-group-expanded" *ngIf="isRollupHeader && !isRollupCollapsed" (click)="this.toggleRollupGroup()">
    <span class="ag-icon ag-icon-tree-open">
    </span>
  </span>
  <span class="ag-group-contracted" *ngIf="isRollupHeader && isRollupCollapsed"  (click)="this.toggleRollupGroup()">
    <span class="ag-icon ag-icon-tree-closed">
    </span>
  </span>
  <span *ngIf="isRollupHeader">{{"multi.mu.rollup.group.header" | translate}}</span>
  <!-- Add any custom elements you want here -->
</div>
